import { render, staticRenderFns } from "./chooseClass.vue?vue&type=template&id=74358969&scoped=true"
import script from "./chooseClass.vue?vue&type=script&lang=js"
export * from "./chooseClass.vue?vue&type=script&lang=js"
import style0 from "./chooseClass.vue?vue&type=style&index=0&id=74358969&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74358969",
  null
  
)

export default component.exports